$(function(){
	// Triggering on 'fields-added' event, fired when new handlebars content pulled-in
	$(window).on('fields-added', function(){
		$('textarea[data-val-regex]:not(.limited)').each(function(i){
			var input = $(this),
				reg = $(this).attr('data-val-regex');
			if(reg.split('[limitWord=')[1].length){
				var limit = reg.split('[limitWord=')[1];

				limit = limit.split(']')[0];

				wordLimit(input,limit);
			}
		});
	}).trigger('fields-added');
});

function wordLimit(el,limit){
	var wordMsg = $('<p class="limitWordRemaining"><strong class="wordLimitRemaining">'+limit+'</strong> words remaining</p>');
	el.after(wordMsg);
	wordMsg.css({
		'text-align':'right',
		'clear':'both',
		'padding-top':'0.5em',
		'font-size':'0.875rem',
		'opacity':'1'
	})
	var $remaining = wordMsg.find('.wordLimitRemaining');
	$remaining.css('color','green');
	el.on('keyup',function(){
		var rem = limit - el.val().split(' ').length;
		var color = 'green';
		if(rem <= 10 || rem <= 0.2 * limit){
			color = 'orange';
		}
		if(rem <= 0){
			color = 'red';
			// SET ERROR STATE
			el.attr('maxlength',el.val().length);
			el.css('color','#888');
		} else{
			// REMOVE ERROR STATE
			el.removeAttr('maxlength');
			el.css('color','');
		}
		$remaining.text(rem).css('color',color);
	});
	if(el.text().length > 1){
		el.trigger('keyup')
	}
	el.addClass('limited');
}